import angular from 'angular';
import { ReportSubscriptionsAdditionalRecipientController } from './additional-recipients-controller';
import reportSubscriptionsAdditionalRecipients from './additional-recipients-component';

export default angular
  .module('reportSubscriptionsAdditionalRecipients', [])
  .controller('ReportSubscriptionsAdditionalRecipientsController', ReportSubscriptionsAdditionalRecipientController)
  .component('reportSubscriptionsAdditionalRecipients', reportSubscriptionsAdditionalRecipients);



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/components/additional-recipients/additional-recipients-module.js